import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { allIcons } from "../../assets";
import appcolors from "../../constants/Colors";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));
let paramsData = {};

const VerifyConfirmDialog = forwardRef(({}, ref) => {
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    isVisible(params) {
      paramsData = params;
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <IconButton
        sx={{ position: "absolute", top: "5px", right: "5px" }}
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>
      <DialogTitle
        variant="h1"
        fontWeight={700}
        fontSize={"1.5rem"}
        fontFamily={"inter"}
        sx={{ m: 0, p: 2, textAlign: "center" }}
        id="customized-dialog-title"
      >
        Successfully changed{" "}
      </DialogTitle>
      <DialogContent>
        {paramsData?.type === "save_new_client" && (
          <Typography variant="body1" textAlign={"center"}>
            You done another appointment so wait for client review you earn 20
            SAR
          </Typography>
        )}
        <Typography variant="body1" textAlign={"center"}>
          Now you can login again with new password If you feel issue feel free
          to <span style={{ color: appcolors.primary }}>contact us</span>{" "}
        </Typography>
        <Box my={3} textAlign={"center"}>
          <img src={allIcons.conformIcon} alt={"confirm-icon"} width={40} />
        </Box>
      </DialogContent>
    </BootstrapDialog>
  );
});

export default VerifyConfirmDialog;
